import { render, staticRenderFns } from "./TagTable.vue?vue&type=template&id=c8beb364&scoped=true&"
import script from "./TagTable.vue?vue&type=script&lang=js&"
export * from "./TagTable.vue?vue&type=script&lang=js&"
import style0 from "./TagTable.vue?vue&type=style&index=0&id=c8beb364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8beb364",
  null
  
)

export default component.exports